import { render, staticRenderFns } from "./ReportWholesalers.vue?vue&type=template&id=cfa2d92a&scoped=true&"
import script from "./ReportWholesalers.vue?vue&type=script&lang=js&"
export * from "./ReportWholesalers.vue?vue&type=script&lang=js&"
import style0 from "./ReportWholesalers.vue?vue&type=style&index=0&id=cfa2d92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa2d92a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VSelect})
